import React from "react";

export default function MotorbikeIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 294.411"
            fill="currentColor"
            {...props}
        >
            <g transform="translate(409.6 192.011)">
                <path
                    d="M51.2,320A51.2,51.2,0,1,1,0,371.2,51.2,51.2,0,0,1,51.2,320Zm0,76.8a25.6,25.6,0,1,0-25.6-25.6A25.631,25.631,0,0,0,51.2,396.8Z"
                    transform="translate(0 -320)"
                />
            </g>
            <g transform="translate(51.2 192.011)">
                <path
                    d="M409.6,320a51.2,51.2,0,1,1-51.2,51.2A51.2,51.2,0,0,1,409.6,320Zm0,76.8A25.6,25.6,0,1,0,384,371.2,25.631,25.631,0,0,0,409.6,396.8Z"
                    transform="translate(-358.4 -320)"
                />
            </g>
            <g transform="translate(0 0)">
                <path
                    d="M153.6,268.8c52.079,0,94.729,39.219,101.1,89.6h36.54l-19.917-89.6H64a12.8,12.8,0,0,1,0-25.6H320a12.8,12.8,0,0,1,0,25.6H297.557l19.917,89.6H410.9c.034-.247.128-.478.162-.734a12.6,12.6,0,0,1-.256-1.263c0-114.7-38.272-209.8-38.647-210.748a12.8,12.8,0,0,1,23.7-9.7c.179.452.888,2.21,1.886,4.847h26.266v25.6H406.512a666.77,666.77,0,0,1,27.571,139.247A101.065,101.065,0,0,1,512,268.8v25.6A75.656,75.656,0,0,0,436.489,384H229.112A76.81,76.81,0,1,0,78.09,384H52.49A102.1,102.1,0,0,1,51.2,371.2,102.513,102.513,0,0,1,153.6,268.8Z"
                    transform="translate(-51.2 -127.989)"
                />
            </g>
        </svg>
    );
}
